export const couponModes = [
    {
        label: "Random Code",
        value: "RANDOM"
    },
    {
        label: "Fixed Code",
        value: "FIXED"
    }
]